module.exports = __webpack_public_path__ + "static/media/banner1.7f01efa0.png";